module.exports = __webpack_public_path__ + "static/magura-logo-5146a04161689da3703cb438cf787338.png";